module.exports = __webpack_public_path__ + "static/media/list-ui-alt.1250a56b.svg";